import React from "react";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import { connect } from "react-redux";
import language from "../../language";
import { getStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { getAllCoreIntegrationServices } from "../../queries/serviceAccount/serviceAccountQuery";
import api from "../../utils/api";
class NewAccount extends React.Component {
  state = {
    error: {},
    name: "",
    description: "",
    isSubmitting: false,
    status: {
      label: "Active",
      value: true,
    },
    integrations: [],
    profiles: [],
  };

  componentDidMount = async () => {
    this.getIntegrationServices();

    if (this.props.id) {
      this.setState({
        ...this.props,
      });
    }
  };

  getIntegrationServices = async (isLoadingProfiles) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingProfiles });

      const integrationServices = await getAllCoreIntegrationServices(
        defaultLanguage,
        {
          listType: "dropdown",
        }
      );

      this.setState({
        integrationServices,
        isLoadingProfiles: false,
      });
    } catch (error) {
      this.setState({ isLoadingProfiles: false });
    }
  };

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target ? e.target.value : e,
    });
  }

  validateForm() {
    let { error, name, integrationService } = this.state;

    if (name === "") {
      error.name = language[this.props.defaultLanguage].name_required;
    }

    if (!integrationService) {
      error.integrationService =
        language[this.props.defaultLanguage].integration_profile_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let { error, name, description, status, integrationService } = this.state;
    const { id } = this.props;

    let user = await getStorage();

    if (Object.keys(error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      const options = {
        method: "POST",
        url: `${api("core")}/service/account`,
        data: {
          name,
          description,
          active: status.value,
          serviceAccountId: "",
          integrationServices: integrationService?.map((el) => el.value) || [],
        },
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + user.accessToken,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "service_account_update_success"
                : "service_account_added_success"
            ]
          );

          this.props.getData();
          this.props.handleCloseModal();
        })
        .catch((error) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "error",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "service_account_update_error"
                : "service_account_added_error"
            ]
          );
        });
    }
  };

  render() {
    return (
      <>
        <div className="card-body">
          <Input
            label={language[this.props.defaultLanguage].name}
            placeholder={language[this.props.defaultLanguage].name_placeholder}
            value={this.state.name}
            onChange={(e) => this.onChangeInput("name", e)}
            error={this.state.error.name}
          />
          <Input
            label={language[this.props.defaultLanguage].description}
            placeholder={
              language[this.props.defaultLanguage].description_placeholder
            }
            value={this.state.description}
            onChange={(e) => this.onChangeInput("description", e)}
            error={this.state.error.description}
          />
          <Select
            options={this.state.integrationServices}
            label={language[this.props.defaultLanguage].integration_services}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.integrationService}
            onChange={(e) => this.onChangeInput("integrationService", e)}
            error={this.state.error.integrationService}
            isLoading={this.state.isLoadingProfiles}
            isMulti
          />
          {/* {this.state.integrationProfile && (
            <Select
              options={this.state.integrationProfile.profiles}
              label={language[this.props.defaultLanguage].profiles}
              placeholder={language[this.props.defaultLanguage].select}
              value={this.state.profile}
              onChange={(e) => this.onChangeInput("profile", e)}
              error={this.state.error.profile}
              isLoading={this.state.isLoadingProfiles}
            />
          )} */}
          <Select
            options={[
              { label: "Active", value: "true" },
              { label: "Inactive", value: "false" },
            ]}
            label={language[this.props.defaultLanguage].status}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.status}
            onChange={(e) => this.onChangeInput("status", e)}
            error={this.state.error.status}
          />
        </div>
        <div className="modal-footer">
          <Button
            type="link"
            className="btn-transparent"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            isSubmitting={this.state.isSubmitting}
            onPress={this.onSubmit.bind(this)}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewAccount);
